import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export function taskGroupReducer(state = initialState.taskGroup, action) {
	switch (action.type) {
		case types.GET_TASKGROUP_BY_ID: {
			return action.response.taskGroups[0];
		}
		default:
			return state;
	}
}
